// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__t_Bkm","title":"style_title__MdTFl"};